var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-2"},[_vm._m(0),_c('TabsVue',{attrs:{"tabs":_vm.tabs}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-lg px-5 py-2"},[_c('span',{staticClass:"text-success"},[_c('i',{staticClass:"fas fa-download"})]),_vm._v(" "),_c('span',{staticClass:"text-blue-600"},[_c('i',{staticClass:"fas fa-angle-down"})])])
}]

export { render, staticRenderFns }